<template>
    <div class="promotion-allocation-area__data" :class="colourClass">
        <losenge-monetary-display
            :compact="true"
            :incremental-amount="incrementalAmount"
            :efficiency="efficiency"
        />
    </div>
</template>

<script>
import { get } from 'lodash';
import promotionCellRendererMixin from './promotion-cell-renderer-mixin';

export default {
    name: 'PromotionKpiRenderer',
    mixins: [promotionCellRendererMixin],
    computed: {
        incrementalAmount() {
            return get(this.params.data, this.params.incrementalAmountPath);
        },
        efficiency() {
            return get(this.params.data, this.params.efficiencyPath);
        },
    },
};
</script>
